
import VideoOverlay from '../video-overlay/video-overlay';

export default class Video {

  constructor ($el) {

    this.$el = $el;
    this.videoId = $el.dataset.videoId;
    this.consentManager = window.klaro.getManager();
    this.consent = this.checkConsent();

    // source image component the overlay should be transitioned from
    this.$source = $el.querySelector('.image');

    // bind click event
    $el.addEventListener('click', this.onClick.bind(this));
  }

  onClick (evt) {
    evt.preventDefault();

    // make sure there's a video to show
    if (typeof this.videoId !== 'undefined'
      && this.$source !== null) {

      if (!this.consent) {
        this.addConsentWrapper();
        this.setConsentInterval();
      }
      else {
        this.showOverlay();
      }

    }
  }

  addConsentWrapper() {
    var consentWrapper = this.$el.parentNode.getElementsByClassName('video-consent-wrapper')[0];
    var replacementPlaceholder = this.$el.parentNode.getElementsByClassName('replacement-placeholder')[0];

    // prepare parent variable, move video inside the Klaro's consent wrapper
    if (typeof replacementPlaceholder !== 'undefined') {
      var parent = this.$el.parentNode;
      replacementPlaceholder.replaceWith(this.$el);
      this.$el = parent.querySelector('a.video');

      consentWrapper.style.display = 'block';
    };
  }

  setConsentInterval() {
    // set interval for checking if the user gave their consent
    this.consentInterval = setInterval(this.videoOnConsent.bind(this), 100);
  }

  videoOnConsent() {
    // update this.consent or show video overlay if consent is given
    if (!this.consent) {
      this.consent = this.checkConsent();
    }
    else {
      this.showOverlay();
    }
  }

  showOverlay() {
    if (typeof this.consentInterval !== 'undefined') {
      clearInterval(this.consentInterval);
    }
    var consentWrapper = this.$el.parentNode.parentNode.parentNode.parentNode.getElementsByClassName('video-consent-wrapper')[0];
    consentWrapper.style['padding-bottom'] = 'unset';
    const overlay = new VideoOverlay(this.videoId);
    overlay.show(this.$source);
  }

  checkConsent() {
    // getConsent('youtube') should be the working solution
    var videoConsent = this.consentManager.getConsent('youtube');

    // but we also need to check if it's modified by klaro and is visible as a
    // fallback option when getConsent('youtube') returns false
    if (!videoConsent) {
      var parent = this.$el.parentNode;
      var modifiedByKlaro = parent.getAttribute('data-modified-by-klaro') === 'yes';

      if (modifiedByKlaro) {
        var parentStyle = window.getComputedStyle(parent);
        if (parentStyle.display !== 'undefined' && parentStyle.display !== 'none') {
          videoConsent = true;
        }
      }
    }

    // load video when consent is received
    if (videoConsent) {
      return true;
    }

    return false;
  }
}
